<template>
  <div>
    <v-autocomplete
      ref="autocompleteRef"
      v-model="select"
      :items="items"
      :loading="isLoading"
      :disabled="isLoading"
      @change="setProviderId"
      :label="$t('filterByGameProviders')"
      item-text="provider"
      item-value="id"
      prepend-icon="mdi-dice-multiple"
      dense
      filled
      solo-inverted
      clearable
      hide-details
      return-object
      :no-data-text="$t('autoCompleteNoData')"
      @click:clear="clearable()"
      :rules="rules"
    >
      <template v-slot:item="{item}">
          <v-img
            max-width="20px"
            :src="encodeURI(`https://cdn.softswiss.net/logos/providers_small/${$vuetify.theme.dark ? 'white' : 'black'}/${item.provider_id}.svg`)"
          ></v-img>
          <span class="ml-3">
            {{ item.provider }}
          </span>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
export default {
  name: "components-common-filter-autocomplete-providers-by-operator",
  props: ["rules"],
  data: () => ({
    select: null,
    isLoading: false,
    items: [],
    search: null,
  }),

  mounted() {
    if (
      this.$route.name === "ListGames" ||
      this.$route.name === "CasinoListBetOnline" ||
      this.$route.name === "CollaboratorListGames" ||
      this.$route.name === "CollaboratorCasinoListBetOnline"
    ) {
      this.getProvidersByOperator()
    }
  },

  watch: {
    $route(val) {
      if(
        val.name === "CasinoListBetOnline" ||
        val.name === "ListGames" ||
        val.name === "CollaboratorListGames" ||
        val.name === "CollaboratorCasinoListBetOnline"
      ) {
        this.getProvidersByOperator()
      }
    }
  },

  methods: {
    async getProvidersByOperator() {
      this.isLoading = true;
      this.$axios
        .post(`${this.$prefix()}/cassino/GamesAgregation/ListProviderbyOperator`)
        .then((response) => {
          this.items = response.data.dados
        })
        .catch(() => {})
        .finally(() => this.isLoading = false)
    },

    clearable() {
      this.$store.commit("setProviderId", "");
      this.select = null
    },

    setProviderId(providerId) {
      if (!providerId) return;
      this.$store.commit("setProviderId", providerId ? providerId : "");
    },
  },
};
</script>
